<!-- -------- desktop header --------- -->
<div class="header d-none d-lg-block" [ngClass]="{ scrolled: isScrolled }">
  <div class="d-flex justify-content-between align-items-center w-100 menu-header">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center w-100">
        <a class="cursor-pointer d-flex align-items-center p-0"
          routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" #navigation
          (click)="addActive($event, '')">
          <svg-icon src="/assets/images/svg-icons/logo.svg"
            [svgStyle]="{ 'width.px': '151', 'height.px': '40' }"></svg-icon>
        </a>

        <div class="menu-item d-flex align-items-center">

          <a class="mx-2" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
            fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName)" title="{{ item.routeName }}"
            *ngFor="let item of navigations">{{ item.navName | translate }} </a>
          <a class="mx-2" href="https://particula.io/" title="{{ 'top_navigation.nav_rating' | translate }}"
            target="_blank">{{ 'top_navigation.nav_rating' | translate }}</a>
          <a class="mx-2" href="https://qelt.ai" title="{{ 'top_navigation.nav_layer1' | translate }}"
            target="_blank">{{ 'top_navigation.nav_layer1' | translate }}</a>
        </div>

        <!-- ---------- Social network --------- -->
        <!-- <span class="ms-3 social-wrap">
            <a *ngFor="let item of social" href="{{ item.link }}" class="link m-0" target="_blank" (click)="vwoData(item.alt)">
              <img src="{{ item.img }}" alt="{{ item.alt }}" loading="eager" />
            </a>
          </span> -->
        <div class="d-flex align-items-center">
          <!--- buynow wallet/address --->
          <div class="btn btn-primary font-14 small ms-2" (click)="showWidget('home')" *ngIf="!walletAddress">{{
            'misc.join_presale' | translate }}</div>
          <div class="btn btn-primary font-14 small ms-2" (click)="disconnect()" *ngIf="walletAddress">{{ walletAddress
            |
            trimAddress }}</div>

          <!---language dropdown-->

          <div class="btn-group language ms-2" dropdown>
            <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center">
              <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg"
                [alt]="selectedLanguage.value" loading="lazy">
              <div class="font-12 text-uppercase fw-semibold mx-1 text-white">{{ selectedLanguage.value }}</div>
              <svg-icon class="dropdown ms-2" src="./assets/images/svg-icons/angle-down-arrow.svg"
                [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
            </div>

            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
              <li class="cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
                [ngClass]="{'active': selectedLanguage.value === lang.value}">
                <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}" [fragment]="hashKey || undefined"
                  class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                  <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'"
                    loading="lazy" />
                  <span class="font-16 fw-normal letter-spacing-0 text-white">{{ lang.native_name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- -------- mobile header --------- -->

<div class="header d-block d-lg-none" [ngClass]="{ scrolled: isScrolled }">
  <div class="d-flex justify-content-between align-items-center flex-grow-1 w-100">
    <div class="d-flex justify-content-start align-items-center">
      <a class="cursor-pointer p-0" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
        (click)="openCloseMenu()" #navigation>
        <img src="/assets/images/png/logo.png" class="img-fluid logo" alt="QXMP Logo" loading="eager" />
      </a>
    </div>

    <div class="menu-btn" (click)="openCloseMenu()">
      <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg"
        [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
    </div>
  </div>

  <div class="menu-overlay" *ngIf="showMenu">
    <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">
      <!--- menu links-->
      <div class="d-flex flex-column justify-content-start align-items-start w-100">
        <a class="" *ngFor="let item of navigations" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
          fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName); openCloseMenu()"
          title="{{ item.routeName }}">{{ item.navName | translate }} </a>
        <a class="" href="https://particula.io/" title="{{ 'top_navigation.nav_rating' | translate }}" target="_blank"
          (click)="openCloseMenu()">{{'top_navigation.nav_rating' | translate }}</a>
        <a class="" href="https://qelt.ai" title="{{ 'top_navigation.nav_layer1' | translate }}"
          target="_blank" (click)="openCloseMenu()">{{
          'top_navigation.nav_layer1' | translate }}</a>
      </div>

      <!--- social links --->

      <span class="social-wrap d-flex align-items-center justify-content-center pt-3">
        <a *ngFor="let item of social" href="{{ item.link }}" target="_blank" (click)="vwoData(item.alt)"
          class="d-flex align-items-center justify-content-center">
          <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
        </a>
      </span>

      <!---language dropdown-->
      <div class="btn-group language my-3" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between">
          <div>
            <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg"
              [alt]="selectedLanguage.value" loading="lazy">
            <span class="ms-1 font-16 text-uppercase fw-semi-bold ms-2 text-white">{{ selectedLanguage.value }}</span>
          </div>

          <svg-icon class="dropdown" src="./assets/images/svg-icons/down-arrow.svg"
            [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"></svg-icon>
        </div>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
          <li class="p-0 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
            [ngClass]="{'active': selectedLanguage.value === lang.value}">
            <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}" (click)="openCloseMenu()"
              class="m-0 p-2 lang-link d-flex justify-content-start w-100">
              <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'" loading="lazy" />
              <span class="font-16 fw-normal letter-spacing-0 text-capitalize">{{ lang.native_name }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="btn btn-secondary  mt-4 mx-auto" (click)="showWidget('home'); openCloseMenu()" *ngIf="!walletAddress">
        {{ 'widget.buy_now' | translate }}</div>
      <div class="btn btn-secondary mt-4 mx-auto" (click)="disconnect(); openCloseMenu()" *ngIf="walletAddress">{{
        walletAddress | trimAddress }}</div>
    </div>
  </div>
</div>